<div class="restaurant-hours-inner" *transloco="let t; read: 'RESTAURANT_HOURS_COMPONENT'">
  <span *ngIf="isOpen">
    <span class="success-color">{{ t('OPENED') }}</span>
    <span>{{ t('OPENED_FROM') }}</span>
  </span>
  <span *ngIf="!isOpen">{{ t('CLOSED') }}</span>
  <span>
    {{ t('HOURS_FROM_TO', { from: openedAt! | translocoDate: { timeStyle: 'short' }, to: closedAt! | translocoDate: { timeStyle: 'short' } }) }}
  </span>
</div>
